import { Controller } from "@hotwired/stimulus"

// Kopieert de waarde van het source-target naar het klembord.
export default class extends Controller {
  static targets = ["source", "label"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      if (!this.hasLabelTarget) return
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = "Gekopieerd"
      setTimeout(() => { this.labelTarget.textContent = original }, 2000)
    })
  }
}
